<script setup>
import { computed } from 'vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  conversationId: {
    type: [Number, String],
    required: true,
  },
});

const store = useStore();
const { t } = useI18n();
const currentChat = useMapGetter('getSelectedChat');

const currentOutcome = computed(
  () => currentChat.value?.custom_attributes?.deal_outcome ?? null
);

const setOutcome = async outcome => {
  // Clicar no que já está marcado desmarca (volta a null).
  const next = currentOutcome.value === outcome ? null : outcome;
  const fromStage = currentChat.value?.custom_attributes?.pipeline_stage;

  try {
    await store.dispatch('pipeline/updateOutcome', {
      conversationId: props.conversationId,
      outcome: next,
      fromStage,
    });

    const chat = currentChat.value;
    if (chat?.id) {
      store.commit('UPDATE_CONVERSATION', {
        ...chat,
        custom_attributes: {
          ...chat.custom_attributes,
          deal_outcome: next,
        },
      });
    }

    useAlert(t('PIPELINE.OUTCOME.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(error.message || t('PIPELINE.API.ERROR_MESSAGE'));
  }
};
</script>

<template>
  <div class="flex gap-2 px-1">
    <button
      type="button"
      class="flex-1 py-1.5 text-sm font-medium transition-colors border rounded-md"
      :class="
        currentOutcome === 'won'
          ? 'border-green-500 bg-green-50 text-green-700 dark:border-green-500 dark:bg-green-900/20 dark:text-green-400'
          : 'border-slate-200 text-slate-600 hover:border-green-400 dark:border-slate-700 dark:text-slate-300'
      "
      @click="setOutcome('won')"
    >
      {{ t('PIPELINE.OUTCOME.WON') }}
    </button>
    <button
      type="button"
      class="flex-1 py-1.5 text-sm font-medium transition-colors border rounded-md"
      :class="
        currentOutcome === 'lost'
          ? 'border-red-500 bg-red-50 text-red-700 dark:border-red-500 dark:bg-red-900/20 dark:text-red-400'
          : 'border-slate-200 text-slate-600 hover:border-red-400 dark:border-slate-700 dark:text-slate-300'
      "
      @click="setOutcome('lost')"
    >
      {{ t('PIPELINE.OUTCOME.LOST') }}
    </button>
  </div>
</template>
